import React, { useEffect, useState, useReducer, useRef } from "react";
import { Card, Form, Col, Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { authServices } from "../../services/auth.services"
import { toast } from "react-toastify";
import LoadingBar from "../common-components/toaster/loader/loader";


const ChangePassword = () => {
     const pageTittle = localStorage.getItem("PageTittle")
     const initalstate = {
          "current_Password": "",
          "new_Password": "",
          "confirm_New_Password": "",
          "show_Current_Password": false,
          "show_confirm_pass": false,
          "showPass": false,
     }
     const confirmDiv = useRef()
     const showPassClass = pageTittle === "Student" ? "pass_icn_student" : "pass_icon"
     const [state, dispatcher] = useReducer(reducer, initalstate);
     const [loading, setLoading] = useState(false);



     function reducer(prevState, action) {
          switch (action.type) {
               case 'current':
                    return {
                         ...prevState,
                         current_Password: action.payload
                    }
               case 'new':
                    return {
                         ...prevState,
                         new_Password: action.payload
                    };
               case 'confirm':
                    return {
                         ...prevState,
                         confirm_New_Password: action.payload
                    }
               case 'reset':
                    return {
                         "current_Password": "",
                         "new_Password": "",
                         "confirm_New_Password": "",
                    }
               case 'showCurrPass':
                    return {
                         ...prevState,
                         show_Current_Password: action.payload
                    }
               case 'showPass':
                    return {
                         ...prevState,
                         showPass: action.payload
                    }
               case 'show_confirm_pass':
                    return {
                         ...prevState,
                         show_confirm_pass: action.payload
                    }
               default:
                    break;
          }
     }


     async function submitPassword(e) {
          e.preventDefault();

          if (state.new_Password.length > 0 && state.new_Password === state.confirm_New_Password) {

               setLoading(true)
               try {
                    const response = await authServices.changePassword({ new_password: state.new_Password, old_password: state.current_Password });
                    dispatcher({ type: "reset" })
                    response.code == 200 && toast.success("Password Updated Successfully")
                    setLoading(false)

               } catch (error) {
                    setLoading(false)
                    toast.error(error.response.data.errors.msg)
               }
          } else {
               confirmDiv.current.focus()

               toast.error("New password and Confirm Password is not matched ")
          }

     }


     function addData(action, value) {
          // console.log(action,"<- Action", value,"<- Value")
          dispatcher({ type: action, payload: value })
     }

     if (state.new_Password && state.confirm_New_Password) {
          state.new_Password === state.confirm_New_Password ? confirmDiv.current.style.borderColor = "green" : confirmDiv.current.style.borderColor = "red"
     }
     return (
          <Col md={5}>
               {loading && <LoadingBar />}
               <div className="stdnt_pswd_div">
                    <div className="card_hdng">
                         <h4 className="mb-0">
                              Change Password
                         </h4>
                    </div>
                    <div className="prfl_flds">
                         <Form onSubmit={submitPassword}>
                              <Form.Group
                                   className="mb-3"
                                   controlId="formBasicPassword"
                              >
                                   <Form.Label>
                                        Current Password
                                   </Form.Label>
                                   <div className="d-flex">
                                        <Form.Control
                                             value={state.current_Password}
                                             type={state.show_Current_Password ? "text" : "password"}
                                             placeholder="Enter Current Password"
                                             onChange={(e) => addData('current', e.target.value)}
                                        />
                                        {state.show_Current_Password ? <FaEyeSlash className={showPassClass} onClick={() => {
                                             addData("showCurrPass", false)
                                        }} /> :
                                             <FaEye className={showPassClass} onClick={() => {
                                                  addData("showCurrPass", true)
                                             }} />}


                                   </div>
                              </Form.Group>

                              <Form.Group
                                   className="mb-3"
                                   controlId="formBasicPassword"
                              >
                                   <Form.Label>
                                        New Password
                                   </Form.Label>
                                   <div className="d-flex">
                                        <Form.Control
                                             className="pass-field"
                                             value={state.new_Password}
                                             type={state.showPass ? "text" : "password"}
                                             onChange={(e) => addData('new', e.target.value)}
                                             placeholder="Enter New Password"
                                        />
                                        {
                                             state.showPass ?
                                                  <FaEyeSlash className={showPassClass} onClick={() => {
                                                       addData("showPass", false)
                                                  }} /> :
                                                  <FaEye className={showPassClass} onClick={() => {
                                                       addData("showPass", true)
                                                  }} />
                                        }
                                   </div>
                              </Form.Group>

                              <Form.Group
                                   className="mb-3"
                                   controlId="formBasicPassword"
                              >
                                   <Form.Label>
                                        Confirm New
                                        Password
                                   </Form.Label>
                                   <div className="d-flex">
                                        <Form.Control
                                             className="pass-field"
                                             type={state.show_confirm_pass ? "text" : "password"}
                                             value={state.confirm_New_Password}
                                             ref={confirmDiv}
                                             onChange={(e) => {
                                                  addData("confirm", e.target.value)
                                             }}
                                             placeholder="Confirm New Password"
                                        />
                                        {state.show_confirm_pass ? <FaEyeSlash className={showPassClass} onClick={(e) => {
                                             addData("show_confirm_pass", false)
                                        }} /> :
                                             <FaEye className={showPassClass} onClick={() => {
                                                  addData("show_confirm_pass", true)
                                             }} />
                                        }


                                   </div>

                              </Form.Group>
                              <div style={{
                                   "justify-content": "center",
                                   "align-items": "center",
                                   "display": "flex",
                              }}>
                                   <Button type="submit" disabled={state.new_Password.length < 0}>{state.isLoading ? 'Submitting...' : 'Submit'}</Button>
                              </div>

                         </Form>


                    </div>
               </div>
          </Col >
     );
};

export default ChangePassword;
